import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NoctemProjects.css';

import crpNoctemLogo from '../content/CRPLOGO-removebg.png';

function ProjectsDisplay() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isNoInfoModalOpen, setNoInfoModalOpen] = useState(false);
  const [isParnersModalOpen, setParnersModalOpen] = useState(false);
  const [isTicketingSoonModalOpen, setTicketingSoonModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const noInfoModal = () => {
    setNoInfoModalOpen(!isNoInfoModalOpen);
  };

  const parnersModal = () => {
    setParnersModalOpen(!isParnersModalOpen);
  };

  const ticketingSoonModal = () => {
    setTicketingSoonModalOpen(!isTicketingSoonModalOpen);
  };

  // Static array of provided dates for 2025
  const eventDates = [
    'Saturday, June 28, 2025',
    'Saturday, August 2, 2025',
    'Saturday, August 30, 2025',
    'Saturday, September 27, 2025',
    'Saturday, November 1, 2025',
    'Saturday, November 29, 2025'
  ];

  const handleDateClick = (date) => {
    if (date === 'Saturday, June 28, 2025') {
      window.open('https://www.howler.co.za/crpentertainment', '_blank');
    } else {
      ticketingSoonModal();
    }
  };

  return (
    <div>
      <div className='events'>
        <div className='event-banner-div'>
          <a href='https://nocturnalforever.com/'>
            <h1 className='event-title'>NOCTURNAL</h1>
          </a>
        </div>
        <a href='https://nocturnalforever-darkweb.company.site/' 
           className='event-banner-div'
           target='_blank'>
          <h1 className='event-title'>THE DARK WEB</h1>
        </a>
        <div className='event-banner-div' onClick={noInfoModal}> 
          <h1 className='event-title'>THE HILL</h1>
        </div>
        <div className='event-banner-div' onClick={noInfoModal}>
          <h1 className='event-title'>SCYTHE</h1>
        </div>
        <a href='https://vngelforever.company.site/' 
           target='_blank'
           className='event-banner-div'>
          <h1 className='event-title'>VNGEL</h1>
        </a>
        <div className='event-banner-div' onClick={toggleModal}>
          <h1 className='event-title'>CRP ENT.</h1>
        </div>

        {isModalOpen && (
          <div className="modal-overlay" onClick={toggleModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={toggleModal}>
                ×
              </button>
              <h2 className='event-banner-modal-header'>CRP ENT. Schedule</h2>
              <p className="schedule-subtitle">Event Dates in 2025</p>
              <ul className="schedule-list">
                {eventDates.map((date, index) => (
                  <li 
                    key={index} 
                    className="schedule-list-item" 
                    onClick={() => handleDateClick(date)}
                  >
                    {date}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {isNoInfoModalOpen && (
          <div className="modal-overlay" onClick={noInfoModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={noInfoModal}>
                ×
              </button>
              <h2 className='no-event-banner-modal-header'>SOMETHING IS COMING SOON! YOU CANT SEE THIS ONE YET!</h2>
              <img src={crpNoctemLogo} alt='Noctem' className='no-event-banner-modal-img'/>
              <Link to='/dashboard' className='services-button'>SERVICES</Link>
            </div>
          </div>
        )}

        {isParnersModalOpen && (
          <div className="parner-modal-overlay" onClick={parnersModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={parnersModal}>
                ×
              </button>
              <h2 className='partner-banner-modal-header'>WHO DO WE WORK WITH?</h2>
              <ul className="partners-list">
                <li className='service-list-item1'><a>9 Lives Customs</a></li>
                <li className='service-list-item2'><a>New Age Productions</a></li>
                <li className='service-list-item3'><a>Vngel</a></li>
                <li className='service-list-item4'><a>NetTech</a></li>
              </ul>
              <img src={crpNoctemLogo} alt='Noctem' className='partners-banner-modal-img'/>
            </div>
          </div>
        )}

        {isTicketingSoonModalOpen && (
          <div className="modal-overlay" onClick={ticketingSoonModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={ticketingSoonModal}>
                ×
              </button>
              <h2 className='ticketing-soon-modal-header'>TICKETS COMING SOON!</h2>
              <p className="ticketing-soon-subtitle">Stay tuned for ticketing details for this event.</p>
              <img src={crpNoctemLogo} alt='Noctem' className='ticketing-soon-modal-img'/>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectsDisplay;